import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import {
  Close,
  PlaylistAdd,
  PlayArrow,
  ShoppingCart,
} from '@mui/icons-material';

const ShareLinkModal = ({
  open,
  onClose,
  contentType,
  contentName,
  onQueue,
  onPlay,
  onBuy,
}) => {
  const isSet = contentType === 'set';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="share-link-dialog-title"
      aria-describedby="share-link-dialog-description"
    >
      <DialogTitle id="share-link-dialog-title">
        {contentName
          ? `${contentName} was shared with you. Play now?`
          : 'This was shared with you. Play now?'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="share-link-dialog-description">
          {isSet
            ? 'Would you like to add this set to your queue or play it now?'
            : 'Would you like to purchase this track or play it now?'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {isSet ? (
          <>
            <Button
              onClick={onQueue}
              variant="outlined"
              startIcon={<PlaylistAdd />}
            >
              Queue
            </Button>
            <Button
              onClick={onPlay}
              variant="contained"
              autoFocus
              startIcon={<PlayArrow />}
            >
              Play
            </Button>
          </>
        ) : (
          <>
            <Button
              onClick={onBuy}
              variant="outlined"
              startIcon={<ShoppingCart />}
            >
              Buy
            </Button>
            <Button
              onClick={onPlay}
              variant="contained"
              autoFocus
              startIcon={<PlayArrow />}
            >
              Play
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

ShareLinkModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  contentType: PropTypes.oneOf(['set', 'track']).isRequired,
  contentName: PropTypes.string,
  onQueue: PropTypes.func,
  onPlay: PropTypes.func.isRequired,
  onBuy: PropTypes.func,
};

export default ShareLinkModal;
